// Environment Configuration
export const FRONTEND_BASE =
  import.meta.env.VITE_FRONTEND_DOMAIN || 'http://localhost:9002';
export const BACKEND_BASE =
  import.meta.env.VITE_BACKEND_DOMAIN || 'http://localhost:8000';
export const API_BASE_URL = `${BACKEND_BASE}/api`;

// Cache Management
export const CACHE_KEY_NAME = 'qps-cache-version';
export const CACHE_KEY_VALUE = 'cache-08-11-2025'; // Change to clear all user caches

// Storage Keys
export const AUTH_TOKEN_KEY = 'authTokens';
export const AUTH_USER_KEY = 'authUser';
export const SESSION_ACCESS_KEY = 'access';
export const SESSION_REFRESH_KEY = 'refresh';

// API Configuration
export const REQUEST_TIMEOUT = 30000; // 30 seconds
export const STALE_TIME = 24 * 60 * 60 * 1000; // 24 hours
export const GARBAGE_COLLECTION_TIME = 30 * 60 * 1000; // 30 minutes

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

// File Upload
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_DOCUMENT_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

// Application Features
export const FEATURES = {
  MULTI_TENANT: true,
  ROLE_SWITCHING: true, // For development/testing
  AUDIT_LOGGING: true,
  REAL_TIME_NOTIFICATIONS: false, // TODO: Implement WebSocket
} as const;

// Development Settings
export const DEV_MODE = import.meta.env.DEV;
export const SHOW_DEBUG_INFO =
  DEV_MODE && import.meta.env.VITE_SHOW_DEBUG === 'true';
